export default "__VITE_ASSET__BBtKz7rI__"